export var TableAppearance;
(function (TableAppearance) {
    TableAppearance[TableAppearance["PERFORMANCE_INDIVIDUAL"] = 0] = "PERFORMANCE_INDIVIDUAL";
    TableAppearance[TableAppearance["BENCHMARK_COMPOSITION"] = 1] = "BENCHMARK_COMPOSITION";
    TableAppearance[TableAppearance["REPORT_TABLE_RESULT"] = 2] = "REPORT_TABLE_RESULT";
})(TableAppearance || (TableAppearance = {}));
//# sourceMappingURL=oh-basic-table.types.js.map
